import cookie from 'react-cookie';
import { hashHistory } from 'react-router'
require('es6-promise').polyfill();
require('isomorphic-fetch');

var config = null;

export default {
  getConfig: function(){
    return window.app.config; 
  },
  getAuthenticationHeader: function(){
    var uname = cookie.load('username');
    var pword = cookie.load('password');
    if(!uname || !pword)
      this.navigateToLogin();
    else{
      var passwordValue = atob(pword);
      return 'Basic ' + new Buffer(uname + ':' + passwordValue).toString('base64');
    }
  },  
  navigateToLogin: function(){
    hashHistory.push('/login');
  },
  fetchCurrentUser: function(callback){
    fetch(this.getConfig().webApiUrl + 'api/currentuser', {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: this.getAuthenticationHeader()
        })   
      })
      .then((response) => {
        return {status: response.status, body: response.json()};
      })
      .then((responseJson) => {
        if(responseJson.status === 200){
          responseJson.body.then((user) => {
            callback(user);
          });    
        }
        else
          callback(null);
      })
      .catch((error) => {
        console.error(error);
      });     
  },
  uintToString: function(uintArray) {
    var encodedString = String.fromCharCode.apply(null, uintArray);
    var decodedString = decodeURIComponent(escape(encodedString));
    return decodedString;
  },
  getDataFromApi: function(apiRoute, successCallback, errorCallback){
    fetch(this.getConfig().webApiUrl + apiRoute, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: this.getAuthenticationHeader()
        })   
      })
      .then((response) => {
        return {status: response.status, body: response.json()};
      })
      .then((responseJson) => {
        if(responseJson.status === 200){
          responseJson.body.then((body) => {
            if(successCallback)
              successCallback(body);
          });
        }
        else if(errorCallback)
          errorCallback(responseJson.status);     
      })
      .catch((error) => {
        console.error(error);
        if(errorCallback)
          errorCallback(null);
      });     
  },
  getHTMLFromApi: function(apiRoute, successCallback, errorCallback){
    fetch(this.getConfig().webApiUrl + apiRoute, {
        method: 'GET',
        headers: new Headers({
          'Content-Type': 'text/html; charset=utf-8',
          Accept: 'text/html; charset=utf-8',
          Authorization: this.getAuthenticationHeader()
        })   
      })
      .then((response) => {  
        return {status: response.status, body: response};
      })
      .then((responseJson) => {
        if(responseJson.status === 200){
            if(successCallback)
              successCallback(responseJson.body);
        }
        else if(errorCallback)
          errorCallback(responseJson.status);     
      })
      .catch((error) => {
        console.error(error);
        if(errorCallback)
          errorCallback(null);
      });     
  },  
  postDataToApi: function(apiRoute, data, successCallback, errorCallback){
    fetch(this.getConfig().webApiUrl + apiRoute, {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: this.getAuthenticationHeader()
        }),
        body: JSON.stringify(data)
      })
      .then((response) => {
        return {status: response.status, body: response.json()};
      })
      .then((responseJson) => {
        if(responseJson.status === 201){
          responseJson.body.then((body) => {
            if(successCallback)
              successCallback(body);
          });   
        }
        else if(errorCallback)
          errorCallback(responseJson.status);      
      })
      .catch((error) => {
        console.error(error);
        if(errorCallback)
          errorCallback(null);        
      });
  },
  putDataToApi: function(apiRoute, data, successCallback, errorCallback){
    fetch(this.getConfig().webApiUrl + apiRoute, {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: this.getAuthenticationHeader()
        }),
        body: JSON.stringify(data)
      })
      .then((response) => {
        return {status: response.status, body: response.json()};
      })
      .then((responseJson) => {
        if(responseJson.status === 200){
          responseJson.body.then((body) => {
            if(successCallback)
              successCallback(body);
          });
        } 
        else if(errorCallback)
          errorCallback(responseJson.status);        
      })
      .catch((error) => {
        console.error(error);
        if(errorCallback)
          errorCallback(null);        
      });
  },
  deleteFromApri: function(apiRoute, successCallback, errorCallback){
    fetch(this.getConfig().webApiUrl + apiRoute, {
        method: 'DELETE',
        headers: new Headers({          
          Authorization: this.getAuthenticationHeader()
        })
      })
      .then((response) => {
        return {status: response.status, body: response.json()};
      })
      .then((responseJson) => {
        if(responseJson.status === 200){
          responseJson.body.then((body) => {
            if(successCallback)
              successCallback(body);
          });
        }
        else if(errorCallback)
          errorCallback(responseJson.status);       
      })
      .catch((error) => {
        console.error(error);
        if(errorCallback)
          errorCallback(null);        
      });    
  },
  uploadFileToApi: function(apiRoute, formData, successCallback, errorCallback){
    fetch(this.getConfig().webApiUrl + apiRoute, {
        method: 'POST',
        headers: new Headers({
          Accept: 'application/json',
          Authorization: this.getAuthenticationHeader()
        }),
        body: formData
      })
      .then((response) => {
        return {status: response.status, body: response.json()};
      })
      .then((responseJson) => {
        if(responseJson.status === 200){
          responseJson.body.then((body) => {
            if(successCallback)
              successCallback(body);
          });   
        }
        else if(errorCallback)
          errorCallback(responseJson.status);      
      })
      .catch((error) => {
        console.error(error);
        if(errorCallback)
          errorCallback(null);        
      });    
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/misc/utils.js
 **/